<template>
  <div class="wf-product-room-scene-colors-wrapper">
    <div class="wf-product-room-scene-colors-container container-fluid">
      <div class="wf-product-room-scene-colors">
        <ul
          :class="[
            'wf-product-room-scene-colors-list position-relative',
            { 'scroll-fade-bottom': !isDyelotPopupShowing }
          ]"
        >
          <li
            class="wf-product-room-scene-color-item pdp-color-item"
            v-for="(color, index) in colors"
            :key="`${color.colorNumber}-${color.colorName}`"
          >
            <button
              class="btn wf-product-room-scene-color-item-button"
              type="button"
              :class="
                color.colorNumber === selectedColor.colorNumber
                  ? 'wf-product-room-scene-color-item-button-active'
                  : 'wf-product-room-scene-color-item-button-disabled'
              "
              @click="updateColor(color)"
            >
              <img
                :src="
                  $helpers.getColorThumbnailImageUrl(
                    sellingStyleNumber,
                    color.colorNumber
                  )
                "
                alt="img"
                class=""
                @error="handleImageError"
                :class="
                  color.colorNumber === selectedColor.colorNumber
                    ? 'color-item-button-active'
                    : 'color-item-button-inactive'
                "
              />
              <div
                class="pdp-pdq-overlay"
                v-if="color.customPdqAvailable == true"
              >
                <span
                  class="pdqLogo png-icon png-icon-icons-symbols--ko-txtpdq"
                />
              </div>
            </button>
            <div
              class="wf-product-room-scene-color-item-name d-none d-lg-block mt-1 mb-1"
            >
              {{ color.colorName + (color.customIsDisclaimerColor ? "*" : "") }}
              <br />
              {{ color.colorNumber }}
              <div
                class="instock-available text-success text-capitalize"
                v-if="
                  color.realTimeInventory &&
                    color.realTimeInventory.availableRtlQty > 0 &&
                    !isComingSoonProduct
                "
              >
                <!-- Dyelot popup -->
                <div v-for="(color, indexInner) in productData.colors">
                  <a
                    v-if="indexInner === index"
                    class="text-uppercase cursor-pointer"
                    @click="toggleDyelotPopup(indexInner)"
                  >
                    {{
                      $resourceString[
                        "product.Details.Label.DyelotAvailability"
                      ]
                    }}
                  </a>
                  <div
                    style="position:relative;"
                    v-if="showDyelotPopup[indexInner] && indexInner === index"
                  >
                    <pc-product-dyelots-popup
                      :showPopup="showDyelotPopup[indexInner]"
                      :dyelotObjects="color.dyeLotInfo"
                      @close="toggleDyelotPopup(indexInner)"
                    />
                  </div>
                </div>
                {{ color.realTimeInventory.availableRtlQtyUom }}
                {{ $resourceString["generic.product.avail"] }}
              </div>
              <br />
            </div>

            <div
              v-if="
                color.customIsDisclaimerColor &&
                  color.colorNumber == selectedColor.colorNumber
              "
              class="position-absolute color-disclaimer-message small text-muted"
            >
              {{ $resourceString["pdp.color.disclaimer"] }}
            </div>
          </li>
        </ul>
        <!-- mobile view -->
        <div v-if="selectedColorIndex !== null" class="color-details">
          <div v-if="colors[selectedColorIndex]">
            <div class="wf-product-room-scene-color-item-name d-lg-none">
             <span class="font-weight-normal">{{
                colors[selectedColorIndex].colorName +
                  (colors[selectedColorIndex].customIsDisclaimerColor
                    ? "*"
                    : "")
              }}</span>
              <span class="ml-3 mr-3">
                {{ colors[selectedColorIndex].colorNumber }}
              </span>
              <div
                class="instock-available text-success text-capitalize mb-2"
                v-if="
                  colors[selectedColorIndex].realTimeInventory &&
                    colors[selectedColorIndex].realTimeInventory
                      .availableRtlQty > 0 &&
                    !isComingSoonProduct
                "
              >

                <span class="instock-available text-capitalize text-success">
                  {{
                    colors[selectedColorIndex].realTimeInventory
                      .availableRtlQtyUom
                  }}

                  {{ $resourceString["generic.product.instockavailable"] }}
                </span>
                <!-- Dyelot popup -->
                <div
                  v-for="(color, indexInner) in productData.colors"
                  :key="`popup-${color.colorNumber}`"
                >
                  <a
                    v-if="indexInner === selectedColorIndex"
                    class="text-uppercase cursor-pointer"
                    @click="toggleDyelotPopup(indexInner)"
                  >
                    {{
                      $resourceString[
                        "product.Details.Label.DyelotAvailability"
                      ]
                    }}
                  </a>
                  <div
                    style="position:relative;"
                    v-if="showDyelotPopup[indexInner]"
                  >
                    <pc-product-dyelots-popup
                      :showPopup="showDyelotPopup[indexInner]"
                      :dyelotObjects="color.dyeLotInfo"
                      @close="toggleDyelotPopup(indexInner)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import PcDyelotsPopup from "../product-details-page/pc-product-dyelots-popup.vue";
import { globalIcons } from "../../../constants/global";

export default {
  props: [
    "mappedColors",
    "installationMethods",
    "product",
    "segments",
    "segmentrooms",
    "collectionsegments",
    "roomscenenumbers",
    "segmentRoomScenes"
  ],
  data() {
    return {
      viewMode: "room",
      hasStaticImage: false,
      showDyelotPopup: [],
      dyelotObjects: [],
      selectedColorIndex: null,
      isDyelotPopupShowing: false,
      defaultImage: globalIcons.defaultImage
    };
  },
  computed: {
    ...mapGetters({
      categories: "productDetail/categories",
      sellingStyleNumber: "productDetail/sellingStyleNumber",
      colors: "productDetail/colors",
      selectedColor: "productDetail/color",
      selectedRoomScene: "productDetail/roomScene",
      roomScenes: "productDetail/roomScenes",
      roomSceneIndex: "productDetail/roomSceneIndex",
      categoryName: "productDetail/categoryName",
      productVisualizerURL: "productDetail/productVisualizerURL",
      selectedInstallationMethod: "productDetail/installationMethod",
      isComingSoonProduct: "productDetail/isComingSoonProduct",
      isRug: "productDetail/isRug",
      selectedProduct: "productDetail/selectedProduct",
      productData: "productDetail/productData",
      sortOrder: "filters/sortOrder",
      filters: "filters/filters",
      getMarketSegmentTypes: "productDetail/getMarketSegmentTypes",
      getEnable3DSource: "productDetail/getEnable3DSource",
      getThreeDSourceURL: "productDetail/getThreeDSourceURL",
      getThreeDSourceIcon: "productDetail/getThreeDSourceIcon"
    })
  },
  methods: {
    //TODO: Remove unnecessary code related to room scene component
    ...mapActions({
      setCategories: "productDetail/setCategories",
      setColor: "productDetail/setColor",
      setColors: "productDetail/setColors",
      setRoomSceneIndex: "productDetail/setRoomSceneIndex",
      setRoomScenes: "productDetail/setRoomScenes",
      setCategoryName: "productDetail/setCategoryName",
      setProductVisualizerURL: "productDetail/setProductVisualizerURL",
      setInstallationMethod: "productDetail/setInstallationMethod",
      setInstallationMethods: "productDetail/setInstallationMethods",
      setProductData: "productDetail/setProductData",
      setSellingStyleNumber: "productDetail/setSellingStyleNumber",
      setRoomsFromCategory: "productDetail/setRoomsFromCategory",
      fetchResults: "inspirationPage/fetchResults",
      marketSegmentType: "productDetail/marketSegmentType",
      visibleThreeDButton: "productDetail/visibleThreeDButton"
    }),

    handleImageError(event) {
      event.target.src = this.defaultImage;
    },

    getSelectedSegmentCategory(e, queryCategory) {
      //declare selected category name from dropdown
      let categoryName;
      if (queryCategory) {
        categoryName = queryCategory;
      } else {
        categoryName = e.target.getAttribute("data-name");
      }
      this.setCategoryName(categoryName);

      //updates url with selected category
      this.updateQueryStringParameters(
        this.$config.queryParamNames.CATEGORY_QUERY_PARAM_NAME,
        categoryName
      );
      this.changeInspiration(categoryName);

      //set room scene index back to first scene when category changes
      this.setRoomSceneIndex(0);

      //declare array with backend segment info from Kentico
      const segmentRoomScenesArray = this.segmentRoomScenes.segmentRoomScenes;

      //variable for storing rScenes that match selected category
      let roomSceneIDs = [];

      segmentRoomScenesArray.forEach((element, i) => {
        if (this.categoryName === segmentRoomScenesArray[i].segmentName) {
          roomSceneIDs.push(segmentRoomScenesArray[i].roomScenes.split(","));
        }
      });

      roomSceneIDs = roomSceneIDs[0].map(Number);

      //stores static scenes if selected color has any
      let staticRoomSceneImages = this.selectedColor.roomScenes ?? [];

      //checks to see if current category has static images
      staticRoomSceneImages.length
        ? (this.hasStaticImage = true)
        : (this.hasStaticImage = false);

      //sets room scenes based on conditional
      if (this.hasStaticImage) {
        this.setRoomScenes(
          [].concat(
            roomSceneIDs.map(i => {
              return { type: "interactive", data: i };
            }),
            staticRoomSceneImages.map(s => {
              return { type: "static", data: s };
            })
          )
        );
      } else {
        roomSceneIDs = roomSceneIDs.map(id => ({
          data: id,
          type: "interactive"
        }));
        this.setRoomScenes(roomSceneIDs);
      }

      //updates url with room scene id of selected category
      this.updateQueryStringParameters(
        this.$config.queryParamNames.ROOM_SCENE_QUERY_PARAM_NAME,
        this.roomScenes[0].data
      );
    },
    async changeInspiration(categoryName) {
      await this.marketSegmentType();
      let category = "";
      let isCategoryAvailable = this.getMarketSegmentTypes.find(
        element => element == categoryName
      );
      if (isCategoryAvailable) {
        category = isCategoryAvailable;
      }
      this.fetchResults({
        filter: {
          SegmentType: category,
          sellingStyleNumber: this.productData.sellingStyleNumber,
          Collection: this.productData.collection,
          IncludeTotalResultCount: true,
          PageSize: 15,
          IsAscendingOrder: true,
          IsPDP: true
        },
        includefilters: true
      });
    },
    goToStaticScene: function() {
      //set general scenes to be displayed by changing category name and updating array
      //navigate to static scene by going to last index of array
      this.setCategoryName("General");
      this.updateColor(this.selectedColor);
      this.setRoomSceneIndex(this.roomScenes.length - 1);
    },
    getInstallImgUrl: function() {
      if (this.isRug) {
        return this.$helpers.getRugColorInstallImageUrl(
          this.sellingStyleNumber,
          this.selectedColor.colorNumber,
          this.selectedProduct?.shape,
          this.selectedProduct.productSizeImperial
            .toLowerCase()
            .replace(/ /g, "")
            .split("x")
        );
      }
      return this.$helpers.getColorTopDownInstallImageUrl(
        this.sellingStyleNumber,
        this.selectedColor.colorNumber,
        this.selectedInstallationMethod.name
      );
    },
    updateColor: function(color) {
      // Set color state
      this.setColor(color);
      this.visibleThreeDButton();
      this.selectedColorIndex = this.colors.indexOf(color);
      let url = new URL(window.location);
      // Replace URL path to include updated color
      window.history.replaceState(
        null,
        null,
        `/product/detail/${this.productData.styleNameURL}-${
          this.sellingStyleNumber
        }/${color.colorNumber}${
          url.searchParams ? "?" + url.searchParams.toString() : null
        }`
      );
    },
    setPreviousRoomScene: function() {
      let index = (this.roomSceneIndex - 1) % this.roomScenes.length;
      index = index < 0 ? 0 : index;

      this.setRoomSceneIndex(index);
      this.updateQueryStringParameters(
        this.$config.queryParamNames.ROOM_SCENE_QUERY_PARAM_NAME,
        this.roomScenes[this.roomSceneIndex].data
      );
    },
    setNextRoomScene: function() {
      let index = (this.roomSceneIndex + 1) % this.roomScenes.length;
      index =
        index >= this.roomScenes.length ? this.roomScenes.length - 1 : index;

      this.setRoomSceneIndex(index);
      this.updateQueryStringParameters(
        this.$config.queryParamNames.ROOM_SCENE_QUERY_PARAM_NAME,
        this.roomScenes[this.roomSceneIndex].data
      );
    },
    getRoomSceneImageUrl: function(roomScene, size) {
      if (roomScene.type === "interactive") {
        // Get interactive room scene image
        if (this.isRug) {
          return this.$helpers.getRugRoomSceneImageUrl(
            this.sellingStyleNumber,
            this.selectedColor.colorNumber,
            roomScene.data,
            this.selectedProduct?.shape,
            this.selectedProduct.productSizeImperial
              .toLowerCase()
              .replace(/ /g, "")
              .split("x")
          );
        }
        return this.$helpers.getInteractiveRoomSceneImageUrl(
          this.sellingStyleNumber,
          this.selectedColor.colorNumber,
          roomScene.data,
          this.selectedInstallationMethod?.name,
          size,
          this.product.productTypeDesc,
          this.product.inventoryType
        );
      } else {
        // Get static room scenes from raw URL in data
        return roomScene.data;
      }
    },
    setViewMode: function(viewMode) {
      this.viewMode = viewMode;
    },
    redirectTo3DSource: function(url) {
      window.open(url, "_blank");
    },
    applyPanzoom: function() {
      let panzoomElement = event.target;

      // Clean up existing panzoom instance
      if (panzoomInstance) {
        panzoomInstance.destroy();
      }

      try {
        if (panzoomElement) {
          // Initialize panzoom instance. Preserve previous instance's pan/zoom positions if available
          panzoomInstance = Panzoom(panzoomElement, {
            startScale: panzoomInstance ? panzoomInstance.getScale() : 1,
            startX: panzoomInstance
              ? panzoomInstance.getPan().x
              : (panzoomElement.parentNode.offsetWidth -
                  panzoomElement.offsetWidth) /
                2,
            startY: panzoomInstance
              ? panzoomInstance.getPan().y
              : (panzoomElement.parentNode.offsetHeight -
                  panzoomElement.offsetHeight) /
                2,
            contain: "outside"
          });
        }
      } catch {
        // Fail silently when panzoom can't initialize, likely due to the DOM element being removed
      }
    },
    updateQueryStringParameters: function(queryParameter, value) {
      const url = new URL(window.location);
      if (value === null) {
        url.searchParams.delete(queryParameter);
      } else {
        url.searchParams.set(queryParameter, value);
      }
      window.history.replaceState(
        null,
        null,
        url.origin + url.pathname + "?" + url.searchParams
      );
    },
    toggleDyelotPopup(index) {
      this.selectedColorIndex = index;
      this.$set(this.showDyelotPopup, index, !this.showDyelotPopup[index]);
      this.isDyelotPopupShowing = this.showDyelotPopup.some(show => show);
    }
  },
  created: function() {
    this.setProductData(this.product);
    this.setColors(this.mappedColors);
    this.setSellingStyleNumber(this.product.sellingStyleNumber);
    // Set the color specified in URL path, if available. Otherwise, set first color.
    let colorIndex = 0;
    const pathRegex = /product\/detail\/(?<styleNumber_url>\w+([-]?\w+)*)\/(?<colorNumber>\w+)/;
    const pathMatch = window.location.pathname.match(pathRegex);
    if (pathMatch) {
      colorIndex = Math.max(
        this.mappedColors.findIndex(
          c => c.colorNumber === pathMatch.groups.colorNumber
        ),
        0
      );
    }
    //categories array stores cats from either style level or collection level that are then shown in the dropdown list
    if (!this.segments.length == 0) {
      this.segments.forEach((element, i) => {
        this.categories.push(this.segments[i].DataClass.Data[1]);
      });
    } else {
      this.collectionsegments.forEach((element, i) => {
        this.categories.push(this.collectionsegments[i].DataClass.Data[1]);
      });
    }
    this.updateColor(this.mappedColors[colorIndex]);
    let currentInstallation = this.installationMethods[0];
    this.setInstallationMethods(this.installationMethods);
    let url = new URL(window.location);
    const installationQueryValue = url.searchParams.get(
      this.$config.queryParamNames.INSTALLATION_QUERY_PARAM_NAME
    );
    //sets intial category value from segmentRoomScenes structure
    const categoryQueryValue = this.segmentRoomScenes.segmentRoomScenes[0]
      .segmentName;
    const roomSceneQueryValue = url.searchParams.get(
      this.$config.queryParamNames.ROOM_SCENE_QUERY_PARAM_NAME
    );
    if (installationQueryValue) {
      currentInstallation = this.installationMethods.find(
        i => i.name === installationQueryValue
      );
    } else {
      this.updateQueryStringParameters(
        this.$config.queryParamNames.INSTALLATION_QUERY_PARAM_NAME,
        currentInstallation.name
      );
    }
    if (categoryQueryValue) {
      this.getSelectedSegmentCategory(null, categoryQueryValue);
    } else {
      this.updateQueryStringParameters(
        this.$config.queryParamNames.CATEGORY_QUERY_PARAM_NAME,
        "General"
      );
    }
    if (roomSceneQueryValue) {
      let currentRoomSceneIndex = this.roomScenes.findIndex(
        i => i.data.toString() === roomSceneQueryValue
      );
      if (currentRoomSceneIndex >= 0) {
        this.setRoomSceneIndex(currentRoomSceneIndex);
        this.updateQueryStringParameters(
          this.$config.queryParamNames.ROOM_SCENE_QUERY_PARAM_NAME,
          this.roomScenes[currentRoomSceneIndex].data
        );
      }
    } else {
      this.updateQueryStringParameters(
        this.$config.queryParamNames.ROOM_SCENE_QUERY_PARAM_NAME,
        this.roomScenes[0].data
      );
    }
    this.setInstallationMethod(currentInstallation);

    //Populate dyelotObjects Array
    let numOfColors = this.productData.colors.length;
    for (let i = 0; i < numOfColors; i++) {
      let dyeLotAmt = this.productData.colors[i].dyeLotInfo;

      for (let j = 0; j < dyeLotAmt.length; j++) {
        if (this.productData.colors[i].dyeLotInfo[j] !== undefined) {
          this.dyelotObjects.push(this.productData.colors[i].dyeLotInfo[j]);
        }
      }
    }
    this.dyelotObjects = [];
    this.isDyelotPopupShowing = this.showDyelotPopup.some(show => show);
    this.setProductVisualizerURL(
      this.$helpers.getPatcarftVisualizerLink(
        `${this.productData.inventoryType}-${this.productData.productTypeDesc}`,
        this.sellingStyleNumber,
        this.selectedColor.colorNumber,
        this.selectedInstallationMethod.tricycleCode
      )
    );
  },
  components: {
    "pc-product-dyelots-popup": PcDyelotsPopup
  }
};
</script>

<style></style>
